export const startAtRetirementValidator = (startAtRetirement, startYear) => () => {
  if (!startAtRetirement && !startYear) {
    return ['Please select a valid year'];
  }

  return [];
};

export const annualExpenseValidator = (estimateExpenses, annualExpense) => () => {
  if (!estimateExpenses && !annualExpense) {
    return ['Please select a valid expense estimate'];
  }

  return [];
};
